export default "__VITE_ASSET__ByuGlWPP__"